/**
 * Defence-in-depth HTML sanitiser used wherever we render admin-authored
 * HTML via `dangerouslySetInnerHTML`. Backend `_sanitize_html` is the
 * primary line of defence; this is the second.
 */
import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "h1",
  "h2",
  "h3",
  "h4",
  "ul",
  "ol",
  "li",
  "a",
  "blockquote",
  "hr",
  "span",
  "div",
];

const ALLOWED_ATTR = ["href", "target", "rel"];

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "link"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "style"],
  });
}

/**
 * Convenience for use with `dangerouslySetInnerHTML`.
 *   <div dangerouslySetInnerHTML={safeHtml(value)} />
 */
export function safeHtml(html) {
  return { __html: sanitizeHtml(html) };
}
